module.exports = __webpack_public_path__ + "static/media/tablet_icon.0e2769b1.svg";